import { ButtonProps as _ButtonProps } from './src/components/Button';
export type ButtonProps = _ButtonProps;

export { Button, ButtonLink } from './src/components/Button';
